// src/components/molecules/finder.tsx

import SearchInput from 'src/components/atoms/forms/search-input/search-input';
import type React from 'react';
import { useState } from 'react';

interface FinderProps {
  onSearch: (searchTerm: string) => void;
}

const Finder: React.FC<FinderProps> = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState('');

  const sendSearch = (searchTerm: string) => {
    onSearch(searchTerm);
  };

  return SearchInput({
    sendSearch,
    inputValue,
    onChange: setInputValue,
  });
};

export default Finder;
